import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector, useRoutesWithLang } from '../../../../../../base/hooks';
import { ReactComponent as ConfirmEmailIcon } from '../../../../../assets/img/confirm-email-icon.svg';
import { Confirmation as ConfirmationComponent } from '../../../../../components/Confirmation';
import { __t } from '../../../../../../base/utils/t';
import { settingsActions } from '../../../redux/slice/settingsSlice';
import { recruiterAppActions } from '../../../../../redux/slices/recruiterAppSlice';
import { SettingsRoutes } from '../../../routes';

import '../styles.scss';

export const Confirmation = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {
        changeLogin: {
            fields: { email, emailCode = '' },
            errors,
        },
    } = useAppSelector((state) => state.recruiterAppSettings);
    const settingsRoutes = useRoutesWithLang<typeof SettingsRoutes>(SettingsRoutes);

    const verificationCodeChangeHandler = (value: unknown) => {
        dispatch(
            settingsActions.setChangeLoginField({
                id: 'emailCode',
                value,
            }),
        );
    };

    const submitResendCode = (recaptchaToken: string | null, callback: () => void) => {
        dispatch(recruiterAppActions.sendConfirmationCode(email, recaptchaToken, callback));
    };

    const successCallback = () => navigate(settingsRoutes.Settings);

    const submitCode = () => {
        dispatch(settingsActions.changeLoginSubmit(successCallback));
    };

    const submitChangeConfirmationValue = (newValue: string, recaptchaToken: string | null, callback: () => void) => {
        dispatch(settingsActions.changeLoginSubmitChangeConfirmationValue(newValue, recaptchaToken, callback));
    };

    return (
        <div className='change-login'>
            <div className='change-login__confirmation'>
                <ConfirmEmailIcon className='change-login__icon' />

                <h2 className='change-login__confirmation-title'>{__t('Подтвердите email')}</h2>
                <ConfirmationComponent
                    codeValue={emailCode}
                    confirmationMethod='email'
                    text={
                        <>
                            {__t('Мы отправили письмо с кодом подтверждения на')} <br />
                            <strong>{email}</strong>
                        </>
                    }
                    codeErrors={errors?.emailCode}
                    changeConfirmationValueErrors={errors?.email}
                    updateModalText={__t('На которий мы отправим код для подтверждения')}
                    verificationCodeChangeHandler={verificationCodeChangeHandler}
                    submitCode={submitCode}
                    submitResendCode={submitResendCode}
                    submitChangeConfirmationValue={submitChangeConfirmationValue}
                />
            </div>
        </div>
    );
};
